/** Helpers compartilhados da Academia (layout Netflix, 2026-06). */

export const extractYoutubeId = (url) => {
  if (!url) return null;
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  return (match && match[2].length === 11) ? match[2] : null;
};

export const getYoutubeThumb = (url, quality = 'hqdefault') => {
  const videoId = extractYoutubeId(url);
  return videoId ? `https://img.youtube.com/vi/${videoId}/${quality}.jpg` : null;
};

/** Thumbnail efetiva de um item (capa cadastrada ou frame do YouTube). */
export const getItemThumb = (item) =>
  item?.thumbnail_url || getYoutubeThumb(item?.video_url) || null;

/** Versão em ALTA (heros/superfícies grandes): tenta maxresdefault do
 *  YouTube; o consumidor deve fazer onError -> getItemThumb (hqdefault). */
export const getItemThumbHQ = (item) =>
  item?.thumbnail_url || getYoutubeThumb(item?.video_url, 'maxresdefault') || null;

export const NIVEL_COLORS = {
  iniciante: '#34D399',
  intermediario: '#F59E0B',
  avancado: '#EF4444',
};

/** Item criado há menos de N dias (badge NOVO). Destaque NÃO conta fora da
 *  janela — senão fica em "Recentes" para sempre (achado da auditoria). */
export function isNovidade(item, dias = 30) {
  if (!item?.created_at) return false;
  const criado = new Date(item.created_at).getTime();
  if (Number.isNaN(criado)) return false;
  return Date.now() - criado < dias * 24 * 60 * 60 * 1000;
}

/** Agrupa itens por categoria preservando a ordem de aparição. */
export function groupByCategoria(items) {
  const grupos = new Map();
  (items || []).forEach((item) => {
    const cat = item.categoria || 'Geral';
    if (!grupos.has(cat)) grupos.set(cat, []);
    grupos.get(cat).push(item);
  });
  return grupos;
}

/**
 * Dentro de uma categoria, separa os itens em:
 *  - direct: sem subcategoria (aparecem primeiro, como "Vídeos gerais")
 *  - subs:   Map<nome da subcategoria, itens[]>, na ordem de 1ª aparição
 *
 * Os itens JÁ devem vir ordenados (por `ordem`); a ordem é preservada, então
 * a subcategoria do item de menor `ordem` aparece primeiro. `hasSubs` avisa se
 * há QUALQUER subcategoria — quando não há, a categoria renderiza como fileira
 * única (comportamento antigo, sem aninhamento).
 */
export function groupBySubcategoria(items) {
  const direct = [];
  const subs = new Map();
  (items || []).forEach((item) => {
    const sub = (item.subcategoria || '').trim();
    if (!sub) { direct.push(item); return; }
    if (!subs.has(sub)) subs.set(sub, []);
    subs.get(sub).push(item);
  });
  return { direct, subs, hasSubs: subs.size > 0 };
}
